//@flow
import React, { Component } from "react";
import type { ProductType } from "../types/product.js";
import ImageUnavailable from "./image-unavailable.jpg";

type Props = {
  product: ProductType
};

class ListItemImage extends Component<Props> {
  render() {
    let productData: ProductType = this.props.product;

    return (
      <a
        href={productData.productDetailsUrl}
        className="wishlist-tile__image-container"
      >
        <img
          alt={this.props.product.title}
          src={productData.imageUrl ? productData.imageUrl : ImageUnavailable}
        />
      </a>
    );
  }
}

export default ListItemImage;
